export default __webpack_public_path__ + "static/media/download.f8430472.svg";